import styled from '@emotion/styled'
import { wrap as withStyle, stylesIf } from 'utils/styles'
import { SMALL, DEFAULT } from 'constants/ui'
import Header from 'components/patterns/Typography/Header'

const fontSizes = {
  [SMALL]: '12px',
  [DEFAULT]: '14px',
}

const padding = {
  [SMALL]: '6px 8px',
  [DEFAULT]: '8px 8px',
}

const hidePaginationBtns = `display: none;`

export const tableStyleFn = (props) => {
  const {
    pageSize,
    size,
    plain,
    showEmptyText,
    xScroll,
    pagination: { total },
    theme: {
      fontFamily,
      tableCheckboxHover,
      tableCheckboxChecked,
      tableCheckboxInner,
      tableGrayBackground,
      tableColor,
      tableBorder,
      tableWhiteBackground,
    },
  } = props

  return `
    &&&& {
      ${stylesIf(
        !showEmptyText,
        `.ant-empty-description { display: none; } .ant-table-placeholder { font-size: 0; }`
      )}
      .ant-table-placeholder {
        background: ${tableGrayBackground};
        height: 200px;

        .ant-empty-image { display: none; }
      }

      .ant-table  {
        border-right: 0px;
        border-bottom: 0px;
      }

      .ant-table-column-sorters {
        display: flex;
      }

      table {
        width: 100%;
        text-align: left;
        border-radius: 3px;
        border-collapse: separate;
        border-spacing: 0;
        margin: 0;
        border-right: 1px solid ${tableBorder};
      }

      .ant-table-thead > tr > th,
      .ant-table-tbody > tr > td {
        ${stylesIf(size === DEFAULT, 'height: 32px;')}
        word-break: normal;
        font-family: ${fontFamily};
        font-weight: 300 !important;
        font-size: ${fontSizes[size]};
        line-height: 1.25;
        text-align: left;
        color: ${tableColor};
        padding: ${padding[size]} !important;
        background: ${tableGrayBackground};
        background-color: ${tableGrayBackground};
        border-color: ${tableBorder};
        border-bottom: 1px solid ${tableBorder};
        border-radius: 0px !important;
        border-right: 1px solid ${tableWhiteBackground};

        &:last-of-type {
          border-right: 0px !important;
        }

        &.no-padding {
          padding: 0 !important;
        }

        &.position-relative {
          position: relative;
        }
      }

      .ant-table-tbody > tr > td {
        background: ${tableWhiteBackground};
        background-color: ${tableWhiteBackground};
      }

      .ant-table-header.ant-table-hide-scrollbar {
        overflow: auto !important;
      }

      
      .ant-checkbox-checked .ant-checkbox-inner
      {
        background-color: ${tableCheckboxChecked} !important;
      }

      .ant-checkbox-wrapper:hover .ant-checkbox-inner
      {
        border-color:  ${tableCheckboxHover} !important;
      }

      .ant-checkbox-inner {
        border-color: ${tableCheckboxInner};
      }

      .ant-pagination-item {
        ${stylesIf(total < pageSize, hidePaginationBtns)}

        &:not(.ant-pagination-item-active) {
          border: 1px solid transparent;
        }
      }

      .ant-pagination-next,
      .ant-pagination-prev {
        ${stylesIf(total < pageSize, hidePaginationBtns)}
        border: 1px solid transparent;

        a {
          border: 1px solid transparent;
        }
      }

      .ant-pagination-disabled.ant-pagination-prev,
      .ant-pagination-disabled.ant-pagination-next {
        cursor: default;
      }

      .ant-table-scroll {
        border-bottom: 1px solid ${tableGrayBackground};
      }

      ${stylesIf(
        !xScroll,
        `
        .ant-table { overflow-x: hidden !important; }
        .ant-table-content { overflow-x: hidden !important; }
        .ant-table-body { overflow-x: hidden !important; }
        `
      )}

      .ant-table-pagination,
      .ant-pagination {
        float: left;
      }

      .ant-dropdown-open {
        svg {
          transform: rotate(180deg);
        }
      }

      ${stylesIf(
        plain,
        `
        .ant-table {
          border: 1px solid ${tableBorder};
          border-radius: 3px;
          background: ${tableWhiteBackground};
        }
        .ant-table-placeholder {
          height: auto;
          min-height: 44px;
          background: ${tableWhiteBackground};
        }
        .ant-table-thead > tr > th,
        .ant-table-tbody > tr > td {
          border-right: 0px !important;
          font-weight: 400 !important;
          padding-left: 16px !important;
          padding-right: 16px !important;
        }
        .ant-table-tbody > tr > td {
          height: 35px;
          padding: 0 16px !important;
          vertical-align: middle;
          cursor: default;
        }
        table {
          border-right: 0px;
        }
        .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td,
        .ant-table-tbody > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
          background: ${tableWhiteBackground} !important;
          cursor: default;
        }
        `
      )}
    }
  `
}

export default withStyle(tableStyleFn)

export const TableHeader = styled(Header)`
  margin-bottom: 4px;
`
